import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { Guardian } from '@xaamin/guardian';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import useGlobal from '../../../../store';
import LoadingButton from '../../../../facturotopia/LoadingButton';

const mapState = (store) => {
  return store.modulo.retenciones_masivas.tickets.list;
};

const mapActions = (actions, containers) => {
  return actions.modulo.retenciones_masivas.tickets.list;
};

const RetencionesMasivasTicketsActions = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);

  const handleOnDownloadActionClick = async () => {
    await actions.download({
      download: true,
      from: props.from,
      to: props.to,
      as: 'link',
    });
  };

  const { busy } = state;

  return (
    <>
      {Guardian.allows('retencion.masiva.descargar.tickets') && (
        <LoadingButton
          variant="secondary"
          className="mr-2"
          loading={busy}
          onClick={handleOnDownloadActionClick}
        >
          {busy === true ? 'Procesando' : 'Descargar tickets'}
        </LoadingButton>
      )}

      <Button
        variant="link"
        as={Link}
        className="text-secondary"
        to="/modulos/retenciones-masivas/files"
      >
        Archivos <FontAwesomeIcon icon={['fas', 'chevron-right']} />
      </Button>
    </>
  );
};

export default RetencionesMasivasTicketsActions;
